export enum ApplicationId {
    AdvertiserEvents = 1,
    SubscriberEvents = 2,
    Host = 3,
    WorkerEvents = 4,
    Pos = 5,
    Resy = 6
}